/**
 * Email widgets — visual editing (2026-10-27, user: "widget me v normal edit karne ka rakho").
 *
 * The stored design is turned into a page the admin edits in place (the words of the header,
 * greeting, sign-off and footer), and back. Two things must survive the round trip untouched:
 *   - the {{content}} slot: shown as a locked "Message goes here" box;
 *   - image placeholders (src="{{company_logo}}"): shown as the real logo, stored as the placeholder.
 * Text placeholders ({{customer_name}} …) stay visible as text — they fill in per recipient.
 */

const CONTENT_SLOT = /\{\{\s*content\s*\}\}/g;

const SLOT_BOX = '<div data-ew-slot="content" contenteditable="false" style="margin:4px 0;padding:16px;border:2px dashed #a78bfa;'
  + 'border-radius:8px;background:#f5f3ff;color:#6d28d9;font-family:Arial,sans-serif;font-size:13px;font-weight:600;text-align:center;'
  + 'user-select:none;">✉ Message goes here — the sender writes this part</div>';

// The greeting slot: a locked chip — its words are typed by each sender (2026-10-28).
const GREETING_SLOT = /\{\{\s*greeting\s*\}\}/g;
const GREETING_CHIP = '<span data-ew-slot="greeting" contenteditable="false" style="display:inline-block;padding:2px 10px;'
  + 'border:1.5px dashed #a78bfa;border-radius:6px;background:#f5f3ff;color:#6d28d9;font-family:Arial,sans-serif;font-size:14px;'
  + 'user-select:none;">Hi {{customer_name}}, ✎ greeting — the sender can change it</span>';

const readLogo = () => {
  try { return localStorage.getItem("logo_url") || ""; } catch { return ""; }
};
// A 1×1 transparent image for placeholders with nothing real to show.
const BLANK = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";

/** The design as an editable page. */
export const toEditable = (html) =>
  String(html ?? "")
    .replace(CONTENT_SLOT, () => SLOT_BOX)
    .replace(GREETING_SLOT, () => GREETING_CHIP)
    .replace(/src="(\{\{\s*(\w+)\s*\}\})"/g, (_m, placeholder, key) =>
      `src="${(key === "company_logo" && readLogo()) || BLANK}" data-ew-src="${placeholder}"`);

/** The edited page (the iframe's document.documentElement.outerHTML) back as a design. */
export const fromEditable = (pageHtml) =>
  String(pageHtml ?? "")
    .replace(/<div[^>]*data-ew-slot="content"[^>]*>[\s\S]*?<\/div>/g, "{{content}}")
    .replace(/<span[^>]*data-ew-slot="greeting"[^>]*>[\s\S]*?<\/span>/g, "{{greeting}}")
    .replace(/<img\b[^>]*>/g, (tag) => {
      const original = /data-ew-src="([^"]*)"/.exec(tag);
      return original
        ? tag.replace(/\ssrc="[^"]*"/, ` src="${original[1]}"`).replace(/\sdata-ew-src="[^"]*"/, "")
        : tag;
    })
    .replace(/\s(contenteditable|spellcheck)="[^"]*"/g, "");
